import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  // viewCountryList,
  viewStateList,
} from "../../Redux/Actions/settingsActions";
import { columnsState } from "../../Global Functions/columnsAntd";
import TableComponent from "../../Global Functions/tableComponents";
import toast from "react-hot-toast";

const ListState = () => {
  const { id } = useParams();
  const dispatch = useDispatch();

  const [searchQuery, setSearchQuery] = useState("");
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: ["5", "10", "20", "50"],
  });

  // const STALE_TIME = process.env.REACT_APP_STALE_TIME || 5 * 60 * 1000; // 5min default

  const { loading, states } = useSelector((state) => state.states);
  const { admin } = useSelector((state) => state.admin || {});
  const accessCode = admin?.data?.access_code || [];
  const canAdd = Array.isArray(accessCode) && accessCode.includes('add');
  const canEdit = Array.isArray(accessCode) && accessCode.includes('edit');

  const fetchStates = useCallback(async (page, pageSize, showLoader = true) => {
    const stateData = {
      page,
      limit: pageSize,
      country: id,
      filter: debouncedSearch, 
      is_deleted: false,
    };

    try {
      await dispatch(viewStateList(stateData, showLoader));
    } catch (error) {
      if (!showLoader) toast.error("Failed to fetch states");
    }
  }, [dispatch, id, debouncedSearch]);

  useEffect(() => {
    fetchStates(pagination.current, pagination.pageSize);
  }, [fetchStates, pagination.current, pagination.pageSize]);

  useEffect(() => {
    if (states?.total) {
      setPagination((prev) => ({ ...prev, total: states.total }));
    }
  }, [states?.total]);

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [debouncedSearch]);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => clearTimeout(handler);
  }, [searchQuery]);

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  const columns = useMemo(() => columnsState(canEdit), [canEdit]);

  return (
    <TableComponent
      h3heading="State List"
      buttonhead2={canAdd ? "Add State" : null}
      navigateTo2={canAdd ? `/state/add/${id}` : null}
      buttonhead="Go Back"
      navigateTo={`/country`}
      setState={setSearchQuery} 
      columns={columns}
      rowKey="_id"
      dataSource={states?.data || []}
      pagination={pagination}
      loading={loading}
      onChange={handleTableChange}
    />
  );
};

export default ListState;
